// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileExcelOutlinedSvg from "@fishx/icons-svg/es/asn/PFileExcelOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileExcelOutlined = function PFileExcelOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileExcelOutlinedSvg
  }));
};

PFileExcelOutlined.displayName = 'PFileExcelOutlined';
export default React.forwardRef(PFileExcelOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileExcelOutlined.js
// module id = 3381
// module chunks = 0